import { modelPortfolioPerformanceHeadlineLines } from '../utils/publishedPerformance';
import { mainBookAsOfPhrase } from './mainBookPrerender';

/**
 * Single disclosure block for performance-route prerender HTML (`/open-portfolio`, `/proof`, `/method`).
 * Built only from {@link ../constants/modelPortfolio.ts} + bundled series totals.
 */
export function buildModelPortfolioPrerenderDisclosureText(): string {
  const { line1, line2, line3 } = modelPortfolioPerformanceHeadlineLines();
  return [line2, line1, line3, mainBookAsOfPhrase()].filter(Boolean).join(' ');
}
